import React, { Fragment, useContext } from 'react'
import BulkActionBar from '../../../bulk-action-bar/bulk-action-bar'
import styles from './pupils-bulk-action.styles'
import injectSheet from 'react-jss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBirthdayCake } from '@fortawesome/pro-solid-svg-icons/faBirthdayCake'
import { faLevelUp } from '@fortawesome/pro-solid-svg-icons/faLevelUp'
import { faUsers } from '@fortawesome/pro-solid-svg-icons/faUsers'
import { faUserTimes } from '@fortawesome/pro-solid-svg-icons/faUserTimes'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { faPrint } from '@fortawesome/pro-solid-svg-icons/faPrint'
import { faFileCheck } from '@fortawesome/pro-solid-svg-icons/faFileCheck'
import { faFileTimes } from '@fortawesome/pro-solid-svg-icons/faFileTimes'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'
import pupilsContext from '../pupils.context'
import { AppContext } from '../../../app/app'

const PupilsBulkAction = ({
  classes,
  selectedPupils,
  onSetAgeGroup,
  onAddToGroup,
  retirePupils,
  showSelected,
  showAll,
  showingSelected,
  onRemoveFromGroup,
  onIncrementAge,
  editable,
  canUpdatePermissions,
  addPermission,
  removePermission,
  onExportCSV
}) => {
  const { openPasscodesDialog } = useContext(pupilsContext)
  const { permissionWarning } = useContext(AppContext)
  return (
    <BulkActionBar
      onShowAll={showAll}
      onShowSelected={showSelected}
      show={selectedPupils.length}
      selected={selectedPupils}
      showingSelected={showingSelected}
      renderMessage={selected => `${selected.length} pupils selected`}
      renderContextMenu={({
        Menu,
        MenuItem,
        IconHolder,
        Separator,
        closePopover
      }) => (
        <Menu>
          {editable && (
            <Fragment>
              <MenuItem onClick={() => closePopover() && onSetAgeGroup()}>
                <IconHolder>
                  <FontAwesomeIcon icon={faBirthdayCake} />
                </IconHolder>
                Set age group
              </MenuItem>
              <MenuItem
                onClick={() =>
                  closePopover() &&
                  openConfirmationDialog({
                    bodyText: `Are you sure you want to increment age groups for those ${
                      selectedPupils.length
                    } pupils?`,
                    confirmText: 'Increment age group',
                    action: onIncrementAge
                  })
                }>
                <IconHolder>
                  <FontAwesomeIcon icon={faLevelUp} />
                </IconHolder>
                Increment age group
              </MenuItem>
              <Separator />
            </Fragment>
          )}
          <MenuItem onClick={() => closePopover() && onAddToGroup()}>
            <IconHolder>
              <FontAwesomeIcon icon={faUsers} />
            </IconHolder>
            Add to group
          </MenuItem>
          <MenuItem onClick={() => closePopover() && onRemoveFromGroup()}>
            <IconHolder>
              <FontAwesomeIcon icon={faUserTimes} />
            </IconHolder>
            Remove from group
          </MenuItem>
          <Separator />
          <MenuItem
            onClick={() => {
              closePopover()
              onExportCSV(selectedPupils)
            }}>
            <IconHolder>
              <FontAwesomeIcon icon={faPrint} />
            </IconHolder>
            Export pupil/parent codes
          </MenuItem>
          {canUpdatePermissions && (
            <Fragment>
              <Separator />
              <MenuItem
                onClick={() =>
                  closePopover() && permissionWarning({ action: addPermission })
                }>
                <IconHolder>
                  <FontAwesomeIcon icon={faFileCheck} />
                </IconHolder>
                Add permission to publish
              </MenuItem>
              <MenuItem
                onClick={() =>
                  closePopover() &&
                  permissionWarning({ action: removePermission })
                }>
                <IconHolder>
                  <FontAwesomeIcon icon={faFileTimes} />
                </IconHolder>
                Remove permission to publish
              </MenuItem>
            </Fragment>
          )}
          {editable && (
            <Fragment>
              <Separator />
              <MenuItem
                className={classes.retirePupil}
                onClick={() =>
                  closePopover() &&
                  openConfirmationDialog({
                    bodyText: `Are you sure you want to retire ${
                      selectedPupils.length
                    } pupils?`,
                    confirmText: 'Retire pupils',
                    action: retirePupils
                  })
                }>
                <IconHolder>
                  <FontAwesomeIcon icon={faTimes} />
                </IconHolder>
                Retire pupil
              </MenuItem>
            </Fragment>
          )}
        </Menu>
      )}
    />
  )
}

export default injectSheet(styles)(PupilsBulkAction)
